import { render, staticRenderFns } from "./IntegrationImg.vue?vue&type=template&id=35f19b63&"
import script from "./IntegrationImg.vue?vue&type=script&lang=js&"
export * from "./IntegrationImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports